import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogMechanicalTests } from "../../repositories/CatalogMechanicalTestRepository";
import { useCatalogMechanicalTestContext } from "./CatalogMechanicalTestContext";
import { TableMechanicalTest } from "./components/TableMechanicalTest";

type Props = {};
export const CatalogMechanicalTestPage = (props: Props) => {
	const { state, actions } = useCatalogMechanicalTestContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogMechanicalTestsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogMechanicalTests();
		if (resp.ok) {
			actions.setMechanicalTests(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogMechanicalTestsFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.mechanicalTests) {
		return (
			<>
				<HelmetDexteel title="Mechanical Tests - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableMechanicalTest
								isLoading={isLoading}
								getCatalogMechanicalTestsFromAPI={
									getCatalogMechanicalTestsFromAPI
								}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
